<template>
  <div>
    <!-- block -->
    <div class="block" v-if="download != null">
      <!-- File Type -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>File Type</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2 d-flex mr-5">
          <div class="w-248px mr-5 product-download-autocomplete">
            <v-autocomplete
              v-model="download.type"
              :items="driveTypeOptions"
              placeholder="請選擇File Type"
              item-text="title"
              item-value="value"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
          <div v-if="download.type === 2 || download.type === 4">
            <div class="w-248px">
              <v-text-field
                v-model="download.ver"
                placeholder="請輸入版本"
                outlined
                dense
              ></v-text-field>
            </div>
          </div>
        </div>
      </div>
      <!-- BU -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-5">
          <h4>BU</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="w-248px my-n2">
            <v-autocomplete
              v-model="download.bu_id"
              :items="buTabs"
              placeholder="請選擇所屬BU"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </label>
      <!-- QA 群組[Warranty or FAQ or RMA...] -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>群組</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="w-248px mr-5 product-download-autocomplete">
            <v-autocomplete
              v-model="download.support_categories_id"
              :items="supportcates"
              placeholder="請選擇所屬群組"
              item-text="title"
              item-value="id"
              outlined
              dense>
            </v-autocomplete>
          </div>
        </div>
      </div>
      <!-- File Language -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>File Language</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <div class="w-248px mr-5 product-download-autocomplete">
            <v-autocomplete
              v-model="download.language_id"
              :items="languages"
              placeholder="請選擇語言"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </div>
      <!-- File Name -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-5"><h4>File Name</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <v-text-field
            v-model="download.name"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- File Format -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-5"><h4>File Format</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <v-text-field
            v-model="download.format"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- File Descript -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-5"><h4>File Descript</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <v-text-field
            v-model="download.description"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Update Date -->
      <div class="form-item d-flex pt-5">
        <div class="w-240px mr-5"><h4>Update Date</h4></div>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
          <div class="w-248px mr-5 product-download-autocomplete">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="download.upload_date"
                  placeholder="請選擇日期"
                  outlined
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="download.upload_date"
                @input="dateMenu = false"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>
      </div>
      <!-- Upload File -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Upload File</h4>
          <div class="h5 ink-02-medium--text">檔案大小限制：≤20MB</div>
        </div>
        <div class="flex-grow-1 flew-basis-0">
          <FileUploader
            v-model="download.path"
            :dir="'downloadfile'"></FileUploader>
        </div>
      </div>
      <!-- 圖片 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-10">
          <h4 class="mb-10px">圖片</h4>
          <div class="h5 ink-02-medium--text">
            此圖將顯示於下載中心 <br />
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div>
          <ImgUploader
            :imageUrl.sync="download.image"
            dir="product"></ImgUploader>
        </div>
      </div>
      <!-- 刪除 -->
      <div class="form-item d-flex py-5" v-if="download.id">
        <div class="w-240px mr-5">
          <h4>刪除</h4>
        </div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <deleteDialog @confirm-delete="deleteHandler"></deleteDialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';
import FileUploader from '@/components/FileUploader.vue';
import deleteDialog from '@/components/ConfirmDelete.vue';

export default {
  components: {
    ImgUploader,
    FileUploader,
    deleteDialog,
  },
  data: () => ({
    fileType: '',
    dateMenu: false,
    fileName: '',
    supportcates: [],
    bu: [],
  }),
  computed: {
    ...mapState('language', ['languages']),
    ...mapState(['buTabs']),
    ...mapState('productDownload', ['download', 'driveTypeOptions', 'tagOptions']),
  },
  async created() {
    await this.getLanguages();
    /*
    if (this.download.support_categories_id !== null) {
      this.supportcates = await this.getSupportFilesCates(this.download.support_categories_id);
    }
    */
  },
  watch: {
    async 'download.bu_id'() {
      this.supportcates = await this.getSupportFilesCates();
    },
    'download.type'(newValue) {
      if (newValue !== 2 && newValue !== 4) {
        this.download.ver = '';
      }
    },
    /* async 'download.support_categories_id'(newValue) {
      if (newValue !== '') {
        this.supportcates = await this.getSupportFilesCates(newValue);
      } else {
        this.supportcates = [];
      }
    }, */
  },
  methods: {
    ...mapActions('language', {
      getLanguages: 'find',
    }),
    ...mapActions('notifications', {
      error: 'error',
    }),
    ...mapActions('productDownload', {
      destroyDownload: 'destroy',
    }),
    ...mapActions('qacategory', ['getSupportFilesCates']),
    deleteHandler() {
      const pThis = this;
      this.destroyDownload(this.download.id).then(() => {
        pThis.$router.push({ name: 'FilesDownload' });
      });
    },
  },
};
</script>
<style lang="scss">
.product-download-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }
}
</style>
